import React from 'react';

const ButtonActionContext = React.createContext({});

export const ButtonActionContextProvider = ButtonActionContext.Provider;
export const ButtonActionContextConsumer = ButtonActionContext.Consumer;

export default ButtonActionContext;
